import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import AddEditContact from "../AddEditContact/AddEditContact";
import PrepareDataTable from "./PrepareDataTable";
import RelatedContactList from "../../RelatedContact/RelatedContactList";
import {
  ContactsListContainer,
  Title,
  HeaderWrapper,
  MainTitle,
} from "./ContactList.styled";
import {
  TABLE_CONTACTS_LIST_MAIN,
  TABLE_CONTACTS_LIST,
} from "@utils/constants";
import "./ContactList.scss";
// import AddEditAnalyticalNote from "../AddEditAnalyticalNote/AddEditAnalyticalNote";

/**
 * Contact List,
 * Path - /contacts
 * @see See [Contacts Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2890203160/Contacts+list+-+General+page)
 * @component
 */
const ContactList = (props) => {
  const {
    t,
    columnList,
    companyId,
    page,
    dependancies,
    isCenter,
    parentCompany,
    countryId,
  } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);

  const [isAddContactPopupVisible, setAddContactPopupVisible] = useState(false);

  const createContact = () => {
    setAddContactPopupVisible(true);
  };

  const closeContactCreationPopup = () => {
    setAddContactPopupVisible(false);
  };

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <ContactsListContainer className="contact-notes-list">
      {page === "main" && (
        <>
          <MainTitle>{t("CONTACTS")}</MainTitle>
          <PrepareDataTable
            isRefreshList={isRefreshList}
            updateRefeshStatus={updateRefeshStatus}
            companyId={companyId ? parseInt(companyId, 10) : companyId}
            columnList={columnList}
            contactType={TABLE_CONTACTS_LIST_MAIN}
            dependancies={dependancies}
            page={page}
          />
        </>
      )}
      {page === "list" && (
        <>
          <HeaderWrapper>
            <Title>{t("CONTACTS")}</Title>
          </HeaderWrapper>
          <PrepareDataTable
            isRefreshList={isRefreshList}
            updateRefeshStatus={updateRefeshStatus}
            companyId={companyId ? parseInt(companyId, 10) : companyId}
            columnList={columnList}
            createContact={createContact}
            contactType={TABLE_CONTACTS_LIST}
            dependancies={dependancies}
            page={page}
          />
        </>
      )}
      {page === "company-view" && (
        <>
          {!isCenter && (
            <PrepareDataTable
              isRefreshList={isRefreshList}
              updateRefeshStatus={updateRefeshStatus}
              companyId={companyId ? parseInt(companyId, 10) : companyId}
              columnList={columnList}
              createContact={createContact}
              contactType={TABLE_CONTACTS_LIST}
              dependancies={dependancies}
              page={page}
              companyCountryId={countryId}
            />
          )}
          {isCenter && (
            <RelatedContactList
              entityType="company"
              dependancies={dependancies}
              entityId={companyId ? parseInt(companyId, 10) : companyId}
              companyId={
                parentCompany ? parseInt(parentCompany, 10) : parentCompany
              }
              countryId={countryId}
              headerNotRequired
              columnList={[
                "ID",
                "CONTACT_COMPANY",
                "CONTACT_NAME",
                "CONTACT_FUNCTION",
                "CONTACT_TYPE",
                "CONTACT_COMMUNICATION",
                "ACTIONS",
              ]}
            />
          )}
        </>
      )}
      {isAddContactPopupVisible && (
        <AddEditContact
          title={t("Contact")}
          onClose={closeContactCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          companyId={companyId ? parseInt(companyId, 10) : companyId}
          countryId={countryId}
        />
      )}
    </ContactsListContainer>
  );
};

ContactList.propTypes = {
  t: PropTypes.func.isRequired,
  companyId: PropTypes.number,
  dependancies: PropTypes.string,
  isCenter: PropTypes.bool,
  parentCompany: PropTypes.number,
  countryId: PropTypes.number,
};

ContactList.defaultProps = {
  companyId: null,
  dependancies: "",
  isCenter: false,
  parentCompany: "",
  countryId: null,
};
export default withTranslation()(ContactList);
